import {Component, OnInit} from '@angular/core';
import {FormGroup} from "@angular/forms";
import {FieldConfig} from "@biletix/core/models/base/field-config.model";

@Component({
  selector: 'btx-select',
  templateUrl:'./btx-select.component.html',
  styleUrls: ['./btx-select.component.scss'],
  standalone: false
})
export class BtxSelectComponent implements OnInit {


  field: FieldConfig | any;

  group: FormGroup | any;


  constructor() {
  }

  ngOnInit(): void {
  }

}
